<template>
<main class="container-1">
	<div class="container-header">
		<Breadcrumb
			v-bind:links="routesBread"
		>
		</Breadcrumb>
		<h2>Editar documento</h2>
	</div>

	<div class="container-body">
		<label for="filename">Nombre</label>
		<input id="filename" v-model="doc.filename" type="text" maxlength="150"
		name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required|max:150'"
		:placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

		<label for="description">Descripción</label>
		<input id="description" v-model="doc.description" type="text" maxlength="450"
		name="descripción" :class="{'error' : errors.has('descripción') }" v-validate="'required|max:450'"
		:placeholder="[[errors.has('descripción') ? errors.first('descripción') : 'Ingresa una descripción']]"/>

		<label for="document-groups">Grupos del documento</label>
		<div id="document-groups">
			<div class="group-chips" v-if="doc.id_groups.length">
				<span class="group-chip" v-for="idGroup in doc.id_groups" :key="idGroup">
					{{ groupNameById(idGroup) }}
					<button type="button" class="group-chip-remove" @click="removeGroup(idGroup)">×</button>
				</span>
			</div>
			<select v-model="groupToAdd" :class="{'error': groupError}" @change="addGroup()">
				<option value="" disabled>Selecciona un grupo</option>
				<option v-for="item in availableGroups" :key="item.id" :value="item.id">
					{{ item.name }}
				</option>
			</select>
			<span v-if="groups.length === 0" class="group-empty">No hay grupos disponibles.</span>
		</div>

		<DocumentPreview
			v-if="doc.path"
			:url="contentUrl(doc)"
			:extension="fileExtension(doc)"
			:name="doc.filename"
			:size="doc.file_size"
			collapsible
		/>
		<!-- doc.id recién existe cuando getDoc() resolvió: sin este guard el
		     aviso parpadea en cada carga del formulario. -->
		<div v-else-if="doc.id" class="doc-preview__empty">
			Este documento no tiene archivo asociado.
		</div>

		<div class="container-action-left" style="justify-content: start;">
			<button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
			<button class="btn btn-secondary" :disabled="loading" v-on:click="onClickGoNext()">Actualizar documento</button>
		</div>

			<div v-if="loading">
				Subiendo archivo...
			</div>

		<div v-if="errors.any() || validationMessage" class="validation-summary">
			<div v-if="validationMessage" class="validation-summary__message">
				{{ validationMessage }}
			</div>
			<div v-for="error in errors.items" :key="error.id" class="validation-summary__error">
				{{ error.msg }}
			</div>
		</div>
	</div>
</main>
</template>
<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import DocumentPreview from '@/components/DocumentPreview.vue'
import { restDocument } from '@/components/mixin/restDocument.js'

export default {
	name: 'DocumentsEdit',
	mixins: [restDocument],
	data () {
		return {
			actualFilename: '',
			deletePressed: false,
			validationMessage: '',
			loading: false,
			groupToAdd: '',
			groupError: false
		}
	},
	components: {
		Breadcrumb,
		DocumentPreview
	},
	computed: {
		routesBread: function (){
			return [
				{name: 'Documentos', path: '/documentos'},
				{name: this.doc.filename, path: '/documentos/' + this.$route.params.idDoc},
				{name: 'Editar Documento'},
			]
		},
		availableGroups: function() {
			return this.groups.filter((item) => !this.doc.id_groups.includes(item.id))
		}
	},
	props: [],
	methods: {
		onClickGoBack: function() {
			window.history.length > 1
				? this.$router.go(-1)
				: this.$router.push('/documentos/')
		},
		onClickGoNext: function() {
			this.groupError = this.doc.id_groups.length === 0
			if (this.groupError) {
				this.validationMessage = 'Selecciona al menos un grupo para el documento.'
				return
			}
			this.$validator.validateAll().then(valid => {
				if (!valid) {
					this.validationMessage = 'Hay errores en el formulario.'
					return
				}
				this.loading = true
				return this.putDoc().then(() => { this.loading = false })
			}).catch(() => {
				this.validationMessage = 'Ocurrió un error inesperado'
				this.loading = false
			})
		},
		groupNameById: function(idGroup) {
			const group = this.groups.find((item) => item.id === idGroup)
			return group ? group.name : 'Grupo desconocido'
		},
		addGroup: function() {
			if (this.groupToAdd && !this.doc.id_groups.includes(this.groupToAdd)) {
				this.doc.id_groups.push(this.groupToAdd)
				this.groupToAdd = ''
				this.groupError = false
				if (this.validationMessage === 'Selecciona al menos un grupo para el documento.') {
					this.validationMessage = ''
				}
			}
		},
		removeGroup: function(idGroup) {
			this.doc.id_groups = this.doc.id_groups.filter((item) => item !== idGroup)
		}
	},
	created () {
		this.$store.getters.getPermissions?.documents ? true : this.$router.push('/pagina-no-encontrada')
	},
	mounted () {
		this.getDocumentGroups().catch(() => {})
		this.getDoc()
	}
}
</script>
<style lang="scss" scoped>
.doc-preview__empty {
	margin: 0.75rem 0;
	font-size: 0.85rem;
	color: var(--color-ghost);
}
.validation-summary {
	margin-top: 1rem;
	padding: 1rem;
	border: 1px solid #dc3545;
	border-radius: 4px;
	background-color: #fff5f5;
}
.validation-summary__message {
	color: #dc3545;
	font-weight: 600;
	margin-bottom: 0.75rem;
}
.validation-summary__error {
	color: #dc3545;
	line-height: 1.5;
}
.validation-summary__error:not(:last-child) {
	margin-bottom: 0.25rem;
}

.group-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
}

.group-chip {
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.25rem 0.5rem;
	border-radius: 999px;
	background-color: #e9ecef;
	font-size: 0.85em;
}

.group-chip-remove {
	border: none;
	background: none;
	cursor: pointer;
	font-size: 1em;
	line-height: 1;
}

.group-empty {
	display: block;
	margin-top: 0.35rem;
	color: var(--color-ghost);
	font-size: 0.85rem;
}
</style>
